import { useContext } from "react";
import Context from "./context";

const useOrganizations = () => {
  const organizations = useContext(Context);
  return organizations;
};

export default useOrganizations;
